import { useGetFeatureFlag } from '@/global/hooks'
import {
  ACCREDITED_NETWORK_SURVEY_LIST,
  ACCREDITED_NETWORK_SURVEY_PROVIDERS,
  MEMBER_WANNABE_NAMESPACE
} from '@/global/constants/featureFlags'
import { usePathname } from 'next/navigation'

const useSurvey = (key: 'control' | 'treatment') => {
  const pathname = usePathname()

  const surveyId = useGetFeatureFlag({
    namespace: MEMBER_WANNABE_NAMESPACE,
    key:
      key === 'control'
        ? ACCREDITED_NETWORK_SURVEY_PROVIDERS
        : ACCREDITED_NETWORK_SURVEY_LIST
  })

  const openSurvey = () => {
    if (
      typeof window !== 'undefined' &&
      window.CE2?.showSurvey &&
      surveyId.value &&
      pathname === '/rede-credenciada/prestadores'
    ) {
      window.CE2.showSurvey(surveyId.value as string)
    }
  }

  return { openSurvey }
}

export { useSurvey }
